export default {
   location : "",
   serialNumber:"",
   unitDescription:"",
   rating:"",
   voltage:""   
}